import React from "react";
import Banner from "../../components/Banner";
import Blog from "../../components/Blog";
import Contact from "../../components/Contact";
import SejaSocio from "../../components/Divisors/SejaSocio";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import IniciativasComp from "../../components/IniciativasComp";
import Partner from "../../components/Partner";
import Project from "../../components/Project";
import Region from "../../components/Region";
import BlueWave from "../../components/BlueWave";
import Pix from "../../components/Divisors/Pix";
import VideoBanner from "../../components/VideoBanner";

const Home = () => {
  return (
    <div className="index">
      <Header />
      <Banner />
      <VideoBanner />
      <SejaSocio />
      <Project />
      <Region />
      <IniciativasComp />
      <Pix />
      <Blog />
      <BlueWave />
      <Partner />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
